import script from "./robot.vue?vue&type=script&setup=true&lang=js"
export * from "./robot.vue?vue&type=script&setup=true&lang=js"

import "./robot.vue?vue&type=style&index=0&id=3d60d27c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d60d27c"]])

export default __exports__